export function sanitizeBuyerField(field, value, documentType) {
    if (field === 'document') {
        return documentType === 'PAS' ? value.replace(/[^a-zA-Z0-9]/g, '') : value.replace(/\D/g, '');
    }
    if (field === 'surname' || (field === 'name' && documentType !== 'RUC')) {
        return value.normalize('NFC').replace(/[^\p{L} ]/gu, '');
    }
    return value;
}

export function getBuyerValidationErrors(buyer) {
    const errors = {};
    const documentPattern = buyer.documentType === 'PAS' ? /^[a-zA-Z0-9]+$/ : /^[0-9]+$/;
    if (buyer.document && !documentPattern.test(buyer.document)) {
        errors.document = buyer.documentType === 'PAS'
            ? 'El pasaporte solo permite letras y números, sin espacios ni caracteres especiales.'
            : 'El documento solo permite números, sin espacios ni caracteres especiales.';
    }
    if (buyer.documentType !== 'RUC') {
        ['name', 'surname'].forEach(field => {
            const value = buyer[field].normalize('NFC');
            if (value && (!/^[\p{L} ]+$/u.test(value) || !value.trim())) {
                errors[field] = 'Ingrese solo letras y espacios, sin números ni caracteres especiales.';
            }
        });
    }
    return errors;
}
